import moment from 'moment'
import { alertModal } from './util'

/**
 * 파라미터값의 null, undefined, '' 체크
 * @param value
 * @returns
 */
export const isBlank = (value: string | null | undefined): boolean => {
	if (value === null || value === undefined || value === '') {
		return true
	}
	return false
}

/**
 * input에 숫자만 입력 가능하도록 처리
 * @param value
 * @returns
 */
export const numberOnlyInput = (value: string): string => {
	value = value.replace(/[^0-9]/g, '')
	return value
}

/**
 * 시작일과 종료일 비교 후 결과 반환
 * @param str
 * @returns
 */
export const compareDateValues = (startDate: string, endDate: string) => {
	// 만약 serach.startDate가 serach.endDate보다 크면 alert
	if (moment(endDate).isBefore(startDate)) {
		alertModal('시작일이 종료일보다 큽니다.', 'warning', () => {})
		return false
	}
	return true
}

/**
 * 문자열 내 개행문자를 <br/> 태그로 변환
 * @param value
 * @returns
 */
export const replaceEnterToBr = (value: string): string => {
	return value.replace(/\n/g, '<br/>')
}
